import { useLocation, useNavigate } from "react-router-dom";
import "../styles/projLoginPage.css";
import "../styles/registrationConfirmedPage.css";

export default function RegistrationConfirmedPage() {
  const { state } = useLocation();
  const navigate  = useNavigate();
  const username  = state?.username || "there";
  const email     = state?.email    || "your email address";
  const owlletId  = state?.owlletId || null;

  return (
    <div className="lp-container">
      <div className="lp-card rc-card">

        {/* ── Branding ── */}
        <div className="lp-brand">
          <div className="lp-logo">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
              />
            </svg>
          </div>
          <h1 className="lp-title">Reading Quest</h1>
          <p className="lp-subtitle">Account registered successfully</p>
        </div>

        {/* ── Email icon ── */}
        <div className="rc-icon">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
            />
          </svg>
        </div>

        <h2 className="rc-title">Check your inbox!</h2>
        <p className="rc-greeting">
          Thanks for joining, <strong>{username}</strong>.
        </p>

        {owlletId && (
          <div className="rc-owllet-id">
            <span className="rc-owllet-label">Your Owllet ID</span>
            <span className="rc-owllet-value">{owlletId}</span>
          </div>
        )}

        <p className="rc-body">
          We've sent an activation link to <strong>{email}</strong>. Please
          click the link in that email to activate your account — it's valid for{" "}
          <strong>24 hours</strong>.
        </p>

        <div className="rc-contact-box">
          <p className="rc-contact-label">
            Didn't receive it? Check your spam folder, or contact us:
          </p>
          <a className="rc-contact-email" href="mailto:owlletreading@gmail.com">
            owlletreading@gmail.com
          </a>
        </div>

        <button
          className="lp-submit rc-back-btn"
          onClick={() => navigate("/projLoginPage")}
        >
          Back to Sign In
        </button>
      </div>
    </div>
  );
}
